export default __webpack_public_path__ + "static/media/userprofile.28e44cb7.png";